export default __webpack_public_path__ + "static/media/sign.51b4087b.glb";